import { logger } from "@justhome/common";
import clsx from "clsx";
import Script from "next/script";
import { FC, useCallback } from "react";
import Lazy from "../Lazy";
import styles from "./HubspotForm.module.scss";

export interface HubspotFormProps {
  formId: string;
  id: string;
  isDoubleOptIn?: boolean;
  inverted?: boolean;
}

const HubspotForm: FC<HubspotFormProps> = ({
  formId,
  id,
  isDoubleOptIn,
  inverted,
}) => {
  const containerId = `hbspt-form-${id}`;

  const handleLoad = useCallback(() => {
    if (!window.hbspt) {
      logger.error("", new Error("Hubspot script not loaded."));
      return;
    }

    // https://legacydocs.hubspot.com/docs/methods/forms/advanced_form_options
    window.hbspt.forms.create({
      region: "eu1",
      portalId: "26999576",
      formId: formId,
      locale: "de",
      // The page is enabled for double opt in
      // https://app-eu1.hubspot.com/content-detail/26999576/landing-page/70324482016/performance
      pageId: isDoubleOptIn ? "70324482016" : undefined,
      target: `#${containerId}`,
      cssClass: clsx(styles.form, {
        [styles.inverted as string]: inverted,
      }),
    });
  }, [formId, containerId, isDoubleOptIn, inverted]);

  const handleError = useCallback(() => {
    logger.error("", new Error("Hubspot script not loaded."));
  }, []);

  return (
    <Lazy>
      <div id={containerId}></div>
      <Script
        id="hsforms"
        src="//js-eu1.hsforms.net/forms/embed/v2.js"
        onReady={handleLoad}
        onError={handleError}
      />
    </Lazy>
  );
};

export default HubspotForm;
